import * as React from "react";
import {CSSProperties} from "react";
import {AppointmentStatusEnum} from "../../model/appointment/AppointmentStatus";
import Tooltip from "../../hiberUiKit/src/atoms/Tooltip/Tooltip";
import Routes from "../../navigation/route/Route";
import {RouteComponentProps, withRouter} from "react-router";
import {Option} from "ts-option";
import User from "../../model/user/User";
import DateUtils from "../../utils/DateUtils";
import {DiaryRowAppointment} from "./DayViewTimeLine";
import Appointment from "../../model/appointment/Appointment";
import moment = require("moment");

const classNames = require("classnames");

interface IProps {
	/**
	 * Item data.
	 */
	data: DiaryRowAppointment,
	/**
	 * Grid row.
	 */
	gridRow: number,
	/**
	 * Start time of the diary.
	 */
	startTime: moment.Moment,
	/**
	 * Interval in minutes of the diary.
	 */
	interval: number,
	/**
	 * Event period in minutes.
	 */
	eventPeriod: number,
	/**
	 * Send sales engineer reminder sms.
	 */
	sendSalesEngineerReminderSms: () => void
	/**
	 * Sales engineer.
	 */
	salesEngineer: Option<User>
	/**
	 * Time line element style.
	 */
	style: CSSProperties
}

type Props = IProps & RouteComponentProps<IProps>;

interface State {
	tooltipVisible: boolean
}

class DayViewTimeLineItem extends React.PureComponent<Props, State> {

	timeLineItem: HTMLDivElement;

	constructor(props: Props) {
		super(props);
		this.state = {
			tooltipVisible: false
		};
		this.toggleTooltip = this.toggleTooltip.bind(this);
		this.routeToEdit = this.routeToEdit.bind(this);
		this.renderInfoTooltip = this.renderInfoTooltip.bind(this);
	}

	render() {
		const appointmentDate = this.props.data.appointment.dateTime;
		const startTime = moment(appointmentDate).hours(this.props.startTime.hour()).minutes(this.props.startTime.minutes());
		const timeFromTimelineStart = appointmentDate.diff(startTime, "minutes");
		//first time column is 3, because grid column is numbered from 1, first column is occupied by SE data
		// and second grid column is dummy
		let startColumn = Math.ceil(timeFromTimelineStart / this.props.interval) + 3;
		const appointment = this.props.data.appointment;
		if (startColumn < 2)
			startColumn = 3;
		const gridColumns = `${startColumn} / ${startColumn + this.props.eventPeriod / this.props.interval}`;
		const classFromProps = classNames({
			'c-day-view_se-list_appointment': true,
			'confirmed': appointment.status.value == AppointmentStatusEnum.Confirmed,
			'unconfirmed': appointment.status.value == AppointmentStatusEnum.Unconfirmed
		});
		const style = {gridColumn: gridColumns, gridRow: this.props.gridRow, ...this.props.style};
		return (
			<div style={style}
				 className={classFromProps}
				 ref={tli => this.timeLineItem = tli}
				 onClick={this.toggleTooltip}>
				<div className={"c-day-view_se-list_appointment_content"}>
					<strong className="d-block">
						{`${(this.props.data.isLeadAppointment ? "LEAD-" : "JOB-")}${this.props.data.referenceNumber.getOrElse("")}`}
					</strong>
					<div>{this.props.data.contact.data.displayName()}</div>
					<div>{this.props.data.address.map(a => a.displayName()).orNull}</div>
				</div>
				{this.state.tooltipVisible && this.renderInfoTooltip()}
			</div>
		)
	}

	renderInfoTooltip() {
		return (
			<Tooltip onOutsideClick={this.toggleTooltip} parentRef={this.timeLineItem}>
				<div className={"t-body"}>
					<strong className="d-block">
						{`${(this.props.data.isLeadAppointment ? "LEAD-" : "JOB-")}${this.props.data.referenceNumber.getOrElse("")}`}
					</strong>
					<strong className="d-block">
						{this.props.data.appointment.status.value.capitalize()}
					</strong>
					{this.props.data.appointment.type.map(at => <div>{at.getDisplayName()}</div>).orNull}
					<br/>
					<div>
						{this.props.data.appointment.dateTime.format(DateUtils.DAILY_PLAN_DATE_FORMAT)} <br/>
						{`${this.props.data.appointment.dateTime.format(DateUtils.DAILY_PLAN_TIME_FORMAT)}
						to ${this.props.data.appointment.endDateTime.format(DateUtils.DAILY_PLAN_TIME_FORMAT)}`}
					</div>
					<br/>
					<div style={{whiteSpace: "pre"}}>{this.props.data.contact.data.fullDetails()}<br/></div>
					{this.props.data.address.map(a => {
						return <div>{a.displayName()}<br/></div>
					}).orNull}
					<br/>
					{this.props.data.type.map(jt => {
						return <div>{`${(this.props.data.isLeadAppointment ? "Lead" : "Job")} type: ${jt.name}`}<br/></div>
					}).orNull}
				</div>
				<br/>
				<div className={"t-link"} onClick={this.routeToEdit}>View &amp; edit details</div>
				{this.renderSendAppointmentReminderButton()}
			</Tooltip>
		);
	}

	renderSendAppointmentReminderButton() {
		return this.props.salesEngineer.map(se => {
			if (se.data.mobileNumber.isDefined) {
				return (
					<div className={"t-link"} onClick={this.props.sendSalesEngineerReminderSms}>Send SMS to engineer</div>
				)
			}
			else {
				return null
			}
		}).orNull
	}

	/**
	 * Route to Proper lead or job and pass Comment Id.
	 */
	routeToEdit() {
		this.props.data.referenceNumber.map(rn => {
			if (this.props.data.appointment instanceof Appointment) {
				this.props.history.push(Routes.EditLead(rn));
			}
			else {
				this.props.history.push(Routes.EditJob(rn));
			}
		})
	}

	toggleTooltip() {
		this.setState({tooltipVisible: !this.state.tooltipVisible})
	}
}

export default withRouter<IProps>(DayViewTimeLineItem);